import { actionBuilder } from './actions';
import { SET_AUTHENTICATED, SET_AUTHENTICATED_USER, SET_INTERVAL, SET_SESSION_ACTIVITY } from './types';

const state = {
  authenticated: false,
  authenticatedUser: {
    firstName: null,
    surname: null,
    personalIdentityCode: null,
  },
  interval: null,
  sessionActive: true,
};

const mutations = {
  [SET_AUTHENTICATED]: (state, authenticated) => {
    state.authenticated = authenticated;
  },
  [SET_AUTHENTICATED_USER]: (state, authenticatedUserData) => {
    state.authenticatedUser = {};
    for (const field in authenticatedUserData) {
      if (authenticatedUserData[field]) state.authenticatedUser[field] = authenticatedUserData[field];
    }
  },
  [SET_INTERVAL]: (state, interval) => {
    state.interval = interval;
  },
  [SET_SESSION_ACTIVITY]: (state, isSessionActive) => {
    state.authenticatedUser = isSessionActive;
  },
};

const getters = {
  isAuthenticatedApplicant: (state) => state.authenticated,
  getAuthenticatedUserData: (state) => state.authenticatedUser,
  getIntervalId: (state) => state.interval,
  isSessionActive: (state) => state.sessionActive,
};

/**
 *
 * @param {LoanOriginationClient} client
 * @returns {{mutations: {[p: string]: function(*, *): void, '[SET_AUTHENTICATED]': (function(...[*]=))}, state: {authenticated: boolean}, getters: {isAuthenticatedApplicant: (function(*): boolean)}, actions: {logout: logout, login: login}, namespaced: boolean}}
 */
const moduleBuilder = (client) => {
  return {
    namespaced: true,
    actions: actionBuilder(client),
    state,
    getters,
    mutations,
  };
};

export default { moduleBuilder };
